<template>
    <div>
        <div class="charts-container">
            <CustomerPieChart v-show="!loading" :valueList="tripList"></CustomerPieChart>
            <b-skeleton type="avatar" v-if="loading" class="skeleton-size"></b-skeleton>
        </div>

        <b-table
            :fields="fields"
            :items="items"
            :class="['gk-table gk-table--responsive gk-table--striped gk-table--headed']"
            :busy="loading"
            :tbody-tr-class="rowClass"
            show-empty
            table-busy>
            <template #cell(name)="row">
                <span>{{ row.value }}</span>
                &nbsp;
                <font-awesome-icon v-if="row.item.is_archived" icon="fa-solid fa-folder" />
            </template>
            <template #head(name)>
                <translate>Customer</translate>
                &nbsp;
                <GekkoButton
                    @click="sortByName"
                    :icon="sortNameDesc ? 'fa fa-arrow-down-z-a' : 'fa fa-arrow-up-z-a'"
                    class="p-0 sort-icon-class"
                    variant="link"
                />
            </template>
        </b-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import CarsService from '@/store/services/cars.service'
import TripService from '@/store/services/trip.service'
import CustomerPieChart from '@/components/customer_insight/CustomerPieChart'
import GekkoButton from '@/components/GekkoButton.vue'

export default {
    name: "InsightTripsTable",
    components: {CustomerPieChart, GekkoButton},
    props: {
        customers: {
            type: Array,
            default: () => []
        },
        filters: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            items: [],
            fields: [
                { key: 'name', label: this.$gettext('Customer')},
                { key: 'total_bike', label: this.$gettext('Bike'), thClass: 'th-class', tdClass: 'td-class', sortable: true},
                { key: 'total_train', label: this.$gettext('Public Transport'), thClass: 'th-class', tdClass: 'td-class', sortable: true},
                { key: 'total_trips', label: this.$gettext('Totals'), thClass: 'th-class', tdClass: 'td-class', sortable: true}
            ],
            sortNameDesc: false,
            loading_customers: true,
            loading_filters: true
        }
    },
    computed: {
        ...mapGetters({ 
            getCompanyId: 'main/getCompanyId'
        }),
        tripList() {
            return this.items.filter((item) => item.total_trips > 0).map((item) => { return {'label': item.name, 'value': item.total_trips}})
        },
        loading() {
            return this.loading_customers || this.loading_filters
        }
    },
    watch: {
        customers() {
            this.loading_customers = true
            this.setReportData('customers')
        },
        filters() {
            this.loading_filters = true
            this.setReportData('filters')
        }
    },
    methods: {
        setReportData(loading_type) {
            if (this.$store.getters['getIsPremium']) {
                if (this.customers.length)
                    this.setRealData(loading_type)
            } else
                this.setFakeData(loading_type)
        },
        setRealData(loading_type) {
            let temp_data = []
            temp_data = JSON.parse(JSON.stringify(this.customers))
            temp_data.unshift({'id':null, 'name': this.$gettext('(no customer)')})

            let filters_cars = {
                'start_date': this.filters.start_date,
                'end_date': this.filters.end_date,
                'group_by': 'customer'
            }
            let filters_bike = {
                'start_date': this.filters.start_date,
                'end_date': this.filters.end_date,
                'group_by': 'customer',
                'transport_type': 'bike'
            }
            let filters_train = {
                'start_date': this.filters.start_date,
                'end_date': this.filters.end_date,
                'group_by': 'customer',
                'transport_type': 'train'
            }

            let cars_params = {}
            let promises = []

            let carsPromise = CarsService.listForCompany(this.getCompanyId, cars_params)
            promises.push(carsPromise)
            promises.push(TripService.getTotalKmBusiness(filters_bike))
            promises.push(TripService.getTotalKmBusiness(filters_train))

            Promise.all(promises).then((responses) => {
                temp_data = this.mergeTwoLists(temp_data, responses[1].data, 'id', 'customer', 'total_business_bike', 'total')
                temp_data = this.mergeTwoLists(temp_data, responses[2].data, 'id', 'customer', 'total_business_train', 'total')
                let carKmPromises = []
                let cars = responses[0]
                let carPlates = []

                for(let i=0; i < cars.length; i++) {
                    carPlates.push(cars[i].plate_number)
                    filters_cars.car = cars[i].id
                    let promise = TripService.getTotalKmBusiness(JSON.parse(JSON.stringify(filters_cars)))
                    carKmPromises.push(promise)
                }

                Promise.all(carKmPromises)
                    .then((responses) => {
                        for(let i = 0; i < responses.length; i++){
                            this.totalBusinessCar = responses[i].data
                            temp_data = this.mergeTwoLists(temp_data, this.totalBusinessCar, 'id', 'customer', 'total_business_car' + i, 'total')
                        }
                    })
                    .then(() => {
                        this.items = []

                        for(let i=0;i < temp_data.length; i++){
                            if(isNaN(temp_data[i].total_business_bike))
                                temp_data[i].total_business_bike = 0
                            
                            if(isNaN(temp_data[i].total_business_train))
                                temp_data[i].total_business_train = 0
                            
                            
                            this.items.push({
                                'id': temp_data[i].id,
                                'name': temp_data[i].name,
                                'total_bike': temp_data[i].total_business_bike,
                                'total_train': temp_data[i].total_business_train,
                                'total_trips': temp_data[i].total_business_bike + temp_data[i].total_business_train,
                                'num_of_cars': responses[0].length,
                                'is_archived': temp_data[i].is_archived
                            })
                            
                            for(let j=0; j < responses[0].length; j++) {
                                if(isNaN(temp_data[i]['total_business_car' + j]))
                                    temp_data[i]['total_business_car' + j] = 0;
                                

                                if (this.items[i]) {
                                    this.items[i]['total_car' + j] = temp_data[i]['total_business_car' + j]
                                    this.fields.splice(1, 0, {key: 'total_car' + j, label: carPlates[j], thClass: 'th-class', tdClass: 'td-class', sortable: true})
                                }

                                if (this.items[i])
                                    this.items[i]['total_trips'] += temp_data[i]['total_business_car'+ j]
                            }

                            if (this.items[i])
                                this.items[i]['total_trips'] = parseFloat(this.items[i]['total_trips'].toFixed(2))
                            
                        }

                        this.items = this.items.filter((item) => item['total_trips'] > 0)
                        this.loading_customers = false
                        this.loading_filters = false
                })
            })
        },
        setFakeData(loading_type) {
            this.items = []

            this.items.push({
                "name": "no customer",
                "total_car0": (150),
                "total_car1" : (10),
                "total_bike": (40),
                "total_train": (80),
                "total_trips": (150 + 40 + 10)
            })

            for(let i=1; i <= 4; i++){
                 this.items.push({
                    "name": `${this.$gettext("fake customer")} ${i}`,
                    "total_car0" : (50 * i),
                    "total_car1" : (51 * i),
                    "total_bike": (300 * i),
                    "total_train": (200 * i),
                    "total_trips": ((300 * i) + (200*1) + (50*i) + (51 * i))
                })
            }

            let cars = []
            cars.push({
               "plate_number": "aa-0000"
            })
            cars.push({
               "plate_number": "aa-0001"
            })
            
            if (loading_type === 'customers')
                this.loading_customers = false
            if (loading_type === 'filters')
                this.loading_filters = false
        },
        mergeTwoLists(list1, list2, ifProp1, ifProp2, prop1, prop2) {
            let finalList = list1.map((x) => x)
            for(let i in finalList) {
                for (let j in list2) {
                    if (finalList[i][ifProp1] == list2[j][ifProp2]) {
                        finalList[i][prop1] = list2[j][prop2]
                    }
                }
            }
            return finalList
        },
        sortByName() {
            if (this.sortNameDesc) {
                this.items.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();

                    if (nameA < nameB) {
                        return -1
                    }

                    if (nameA > nameB) {
                        return 1
                    }

                    return 0;
                });
            } else {
                this.items.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();

                    if (nameA > nameB) {
                        return -1
                    }

                    if (nameA < nameB) {
                        return 1
                    }

                    return 0
                })
            }

            this.sortNameDesc = !this.sortNameDesc
        },
        rowClass(item) {
            if (item && item.is_archived)
                return "archived-row"
            return ""
        }
    }
}
</script>

<style scoped>
.charts-container {
    padding-top: 1rem;
    padding-bottom: 1rem;
    display: flex;
    width: 100%;
    justify-content: center;
    overflow: auto;
}

.skeleton-size {
    min-width: 180px;
    width: 450px;
    height: 450px;
}
</style>

<style>
.th-class {
    text-align: right;
}

.td-class {
    text-align: right;
}

.sort-icon-class:hover {
    color: #3f444d;
}

.archived-row {
    color: #bbb;
}
</style>